import { render, staticRenderFns } from "./WorkloadStatsTable.vue?vue&type=template&id=fbd32522&scoped=true&"
import script from "./WorkloadStatsTable.vue?vue&type=script&lang=js&"
export * from "./WorkloadStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkloadStatsTable.vue?vue&type=style&index=0&id=fbd32522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd32522",
  null
  
)

export default component.exports